import * as React from 'react'
import { Link } from 'react-router-dom'
import { useQueryTenantMe } from '../api/useQueryTenantMe'
import { useQuerySubscriptionStatus } from '../api/useQuerySubscriptionStatus'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

export const ExpiredPage: React.FC = () => {
  const { t } = useLocalize()
  const { data: tenant } = useQueryTenantMe()
  const { data: status } = useQuerySubscriptionStatus(tenant?.companyId ?? null)
  const canManage = status?.canManageBilling ?? false

  return (
    <div style={{ maxWidth: 480, margin: '96px auto', padding: 24, textAlign: 'center' }}>
      <h1 style={{ marginBottom: 8 }}>{t('subscription.expired.title')}</h1>
      <p style={{ color: '#6b7280', marginBottom: 24 }}>
        {tenant?.subscriptionExpirationDate
          ? t('subscription.expired.expiredOn', {
              date: new Date(tenant.subscriptionExpirationDate).toLocaleDateString('pl-PL'),
            })
          : t('subscription.expired.suspended')}{' '}
        {canManage
          ? t('subscription.expired.canManageHint')
          : t('subscription.expired.contactAdminHint')}
      </p>
      {canManage && (
        <Link
          to={tenant ? `/checkout?companyId=${tenant.companyId}` : '/checkout'}
          style={{
            display: 'inline-block',
            padding: '12px 24px',
            background: '#2563eb',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: 6,
            fontWeight: 600,
          }}
        >
          {t('subscription.profile.choosePlan')}
        </Link>
      )}
    </div>
  )
}
